import {authAxios} from "./axiosClient";
import {listDuAnURL, exportExcelTempStaffURL, uploadExcelTempURL, exportExcelTongHopCongURL, exportExcelTongCongURL, exportExcelTongHopOTNSURL,
exportExcelTempHolidayURL, uploadExcelHolidayURL, exportExcelStaffURL, exportExcelOTNS_DBURL} from "../constants";

export const GetDataDuAnApi = (params={})=>{
        const url = listDuAnURL;
        return authAxios().get(url,{params})
}

export const TaoDuAnApi = (params={})=>{
        const url = listDuAnURL;
        return authAxios().post(url,params);
}

export const DownloadTempStaffApi = (params={})=>{
        const url = exportExcelTempStaffURL;
        return authAxios().post(url, params, {responseType: 'blob'});
}

export const UploadTempStaffApi = (params={})=>{
        const url = uploadExcelTempURL;
        return authAxios().post(url, params);
}

export const DownloadStaffApi = (params={})=>{
        const url = exportExcelStaffURL;
        return authAxios().post(url, params, {responseType: 'blob'});
}

export const DownloadTongHopCongApi = (params={})=>{
        const url = exportExcelTongHopCongURL;
        return authAxios().post(url, params, {responseType: 'blob'});
}

export const DownloadTongCongApi = (params={})=>{
        const url = exportExcelTongCongURL;
        return authAxios().post(url, params, {responseType: 'blob'});
}

export const DownloadTongHopOTNSApi = (params={})=>{
        const url = exportExcelTongHopOTNSURL;
        return authAxios().post(url, params, {responseType: 'blob'});
}

export const DownloadTempHolidayApi = (params={})=>{
        const url = exportExcelTempHolidayURL;
        return authAxios().post(url, params, {responseType: 'blob'});
}

export const UploadTempHolidayApi = (params={})=>{
        const url = uploadExcelHolidayURL;
        return authAxios().post(url, params);
}

export const DownloadOTNS_DBApi = (params={})=>{
        const url = exportExcelOTNS_DBURL;
        return authAxios().post(url, params, {responseType: 'blob'});
}